import * as Types from '../../declarations'
// import PictureGrid from './components/PictureGrid'
import SectionHeader from './components/SectionHeader'
import HTMLContent from 'components/HTMLContent'

interface Props {
	trip: Types.DB.Models.TripAttributes
}

const Access = ({
	trip: {
		name,
		jsonData: { access },
	},
}: // trip,
Props) => {
	if (!access) return <></>

	// const defaultAltText = getTrekImageAltText(trip, 'getting there')

	return (
		<div id="access-wrapper" className="spacing-between-sections-above">
			<SectionHeader
				title={`${name} access - getting there`}
				subtitle={`How to get to ${name}`}
				section={Types.App.DataTypes.FeedbackSection.ACCESS}
			/>
			{access.description && (
				<HTMLContent
					id="access-description"
					html={access.description}
				></HTMLContent>
			)}
			{/* disabling pictures for now until we have a solution for more legit
			pictures */}
			{/* {access.pictures && (
				<PictureGrid
					pictures={access.pictures}
					defaultAltText={defaultAltText}
				/>
			)} */}
		</div>
	)
}

export default Access
